import { POPULATION_TYPE } from "@/common/models";
import { SharedState } from "@/common/state";
import {
  DrillDownMenuItem,
  UseDrillDownMenu,
} from "@/components/root/drilldown-menu/drilldown-menu.state";

const investigate_menu_item: DrillDownMenuItem = {
  disable: false,
  isCategory: false,
  name: "Investigate",
  icon: "Investigation",
  subItems: [],
  isPremium: false,
  action: "investigate",
};

export const source_row_menu = async (p: { item: any; event: MouseEvent }) => {
  const menu: DrillDownMenuItem[] = [investigate_menu_item];
  const res = await UseDrillDownMenu().show({
    menu,
    event: p.event,
  });
  if (res.didUserSelectedAnAction) {
    SharedState.investigation.investigate({
      ...p.item,
      name: p.item.l0.labelName,
      type: POPULATION_TYPE.LABEL,
    });
  }
};
